var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box-item" },
    [
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "text" }, [
          _c("span", [
            _vm._v(" " + _vm._s(_vm.$dataCheck(_vm.item.title)) + " "),
            _vm.item.currency
              ? _c("span", [_vm._v("(" + _vm._s(_vm.item.currency) + ")")])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "number font-manrope" }, [
          _vm._v(" " + _vm._s(_vm.$dataCheck(_vm.item.count, 0)) + " "),
        ]),
        _c("div", { staticClass: "rate" }, [
          _c(
            "span",
            {
              staticClass: "font-manrope",
              style: _vm.item.rate < 0 ? "color: #00ce47" : "",
            },
            [_vm._v(_vm._s(_vm.$dataCheck(_vm.item.rate)) + "%")]
          ),
          _c("i", {
            staticClass: "iconfont iconChevron-Top",
            style:
              _vm.item.rate < 0
                ? "transform: rotate(180deg);color: #00ce47"
                : "",
          }),
        ]),
      ]),
      _vm.item.icon
        ? _c("div", { staticClass: "box-img" }, [
            _c("i", { staticClass: "iconfont", class: _vm.item.icon }),
          ])
        : _vm._e(),
      _vm._t("icon"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }